import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";

const SearchIcon = ({ height, width, viewBox, color, ...rest }) => (
    <SVG width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/SVG" {...rest}>
        <g stroke={color} strokeWidth="1.08">
            <circle cx="8.12" cy="8.12" r="7.58" />
            <path d="m13.33 13.33 5.84 5.84" />
        </g>
    </SVG>
);

SearchIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

SearchIcon.defaultProps = {
    color: "#282828",
    height: "20px",
    viewBox: "0 0 20 20",
    width: "20px",
};

export default SearchIcon;
